
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { ProfileSection, ProfileSectionError } from "../common/ProfileSection";

export default function DoctorVisit({ profileId }) {
	const [profile, setProfile] = useState({});
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchProfile();
	}, []);

	function fetchProfile() {
		api.profileDetail({
			token: LoginHelper.getToken(),
			profile_id: profileId,
		})
			.then((result) => {
				setProfile(result);
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	if (profile.mode !== "doctor") {
		return null;
	}

	return (
		<ProfileSection title="نوبت‌دهی حضوری">
			<p className="font-Vazir-400 text-[14px] text-grayText text-center mb-4">
				برای رزرو وقت با این درمانگر، دکمه زیر را بزنید.
			</p>
			<Link to={`/visit_doctor_reserve/${profile.id}/`} className="block w-full">
				<span className="flex items-center justify-center w-full bg-cta rounded-xl py-3 text-white font-Vazir-600 text-[14px] hover:opacity-95 transition-opacity">
					دریافت نوبت
				</span>
			</Link>
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
